(function () {
  'use strict';

  function init(root) {
    if (!root || root.getAttribute('data-journal-ready')) return;
    root.setAttribute('data-journal-ready', 'true');

    var cards = Array.prototype.slice.call(root.querySelectorAll('.journal-card'));
    // Every filter control: the Type pills and the options inside the brand dropdown.
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var search = root.querySelector('[data-journal-search]');
    var countEl = root.querySelector('[data-journal-count]');
    var emptyEl = root.querySelector('[data-journal-empty]');
    var moreWrap = root.querySelector('[data-journal-more-wrap]');
    var moreBtn = root.querySelector('[data-journal-more]');
    var clearEls = Array.prototype.slice.call(root.querySelectorAll('[data-journal-clear]'));
    var perLoad = parseInt(root.getAttribute('data-per-load'), 10) || 9;
    var text = {
      one: root.getAttribute('data-count-one') || '{n}',
      other: root.getAttribute('data-count-other') || '{n}',
      more: root.getAttribute('data-more') || '{n}'
    };
    var state = { type: '', brand: '', q: '', limit: perLoad };

    var picker = root.querySelector('[data-journal-picker]');
    var pickerButton = picker && picker.querySelector('[data-journal-picker-button]');
    var pickerValue = picker && picker.querySelector('[data-journal-picker-value]');
    var pickerPanel = picker && picker.querySelector('[data-journal-picker-panel]');
    var pickerBackdrop = picker && picker.querySelector('[data-journal-picker-backdrop]');
    var pickerSearch = picker && picker.querySelector('[data-journal-picker-search]');
    var pickerNone = picker && picker.querySelector('[data-journal-picker-none]');
    var pickerItems = picker ? Array.prototype.slice.call(picker.querySelectorAll('.journal-picker__list li')) : [];

    root.classList.add('is-js');

    function hasControl(group, value) {
      return controls.some(function (control) {
        return control.getAttribute('data-filter') === group && control.getAttribute('data-value') === value;
      });
    }

    function matches(card, s) {
      if (s.type && card.getAttribute('data-type').indexOf(' ' + s.type + ' ') === -1) return false;
      if (s.brand && card.getAttribute('data-brand').indexOf(' ' + s.brand + ' ') === -1) return false;
      if (s.q) {
        var haystack = card.getAttribute('data-search') || '';
        var words = s.q.split(/\s+/);
        for (var i = 0; i < words.length; i++) {
          if (words[i] && haystack.indexOf(words[i]) === -1) return false;
        }
      }
      return true;
    }

    function syncUrl() {
      if (!window.history || !window.history.replaceState || !window.URLSearchParams) return;
      var params = new URLSearchParams(window.location.search);
      // The Type filter is written as "topic" in the address: Shopify copies a "type" parameter
      // into the page's canonical link, which would make every filtered view its own canonical page.
      params.delete('type');
      [['topic', 'type'], ['brand', 'brand'], ['q', 'q']].forEach(function (pair) {
        var value = state[pair[1]];
        if (value) params.set(pair[0], value);
        else params.delete(pair[0]);
      });
      var query = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    }

    function render() {
      var filtered = cards.filter(function (card) { return matches(card, state); });

      cards.forEach(function (card) {
        var index = filtered.indexOf(card);
        card.hidden = index === -1 || index >= state.limit;
      });

      if (countEl) {
        countEl.textContent = (filtered.length === 1 ? text.one : text.other).replace('{n}', filtered.length);
      }
      if (emptyEl) emptyEl.hidden = filtered.length > 0;

      var remaining = filtered.length - state.limit;
      if (moreWrap) moreWrap.hidden = remaining <= 0;
      if (moreBtn && remaining > 0) moreBtn.textContent = text.more.replace('{n}', remaining);

      var selectedBrand = null;
      controls.forEach(function (control) {
        var group = control.getAttribute('data-filter');
        var value = control.getAttribute('data-value');
        var active = state[group] === value;
        control.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && group === 'brand' && value !== '') selectedBrand = control;
        if (value === '') {
          control.disabled = false;
          return;
        }
        // How many articles would be left if this option were chosen, with everything else unchanged.
        var probe = { type: state.type, brand: state.brand, q: state.q };
        probe[group] = value;
        var total = cards.filter(function (card) { return matches(card, probe); }).length;
        control.disabled = total === 0 && !active;
        var badge = control.querySelector('[data-journal-option-count]');
        if (badge) badge.textContent = total > 0 ? total : '';
      });

      if (pickerValue) {
        var nameEl = selectedBrand && selectedBrand.querySelector('.journal-option__name');
        pickerValue.textContent = nameEl ? nameEl.textContent : pickerValue.getAttribute('data-all');
        pickerButton.classList.toggle('is-active', !!selectedBrand);
      }

      var dirty = !!(state.type || state.brand || state.q);
      clearEls.forEach(function (el) {
        if (!el.hasAttribute('data-journal-empty-clear')) el.hidden = !dirty;
      });

      syncUrl();
    }

    // ---------- Brand dropdown ----------

    function filterPicker(query) {
      var q = query.trim().toLowerCase();
      var shown = 0;
      pickerItems.forEach(function (li) {
        var option = li.querySelector('.journal-option');
        var isAll = option.getAttribute('data-value') === '';
        var name = li.querySelector('.journal-option__name').textContent.toLowerCase();
        var visible = !q || (!isAll && name.indexOf(q) !== -1);
        li.hidden = !visible;
        if (visible && !isAll) shown++;
      });
      if (pickerNone) pickerNone.hidden = !q || shown > 0;
    }

    function openPicker() {
      pickerPanel.hidden = false;
      if (pickerBackdrop) pickerBackdrop.hidden = false;
      pickerButton.setAttribute('aria-expanded', 'true');
      // Make sure the whole list is on screen (it opens in place, below the button).
      if (pickerPanel.scrollIntoView) {
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        pickerPanel.scrollIntoView({ block: 'nearest', behavior: calm ? 'auto' : 'smooth' });
      }
      if (pickerSearch) {
        pickerSearch.value = '';
        filterPicker('');
        // Focus the search box with a mouse or keyboard; on touch screens it would pop the keyboard up.
        if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) pickerSearch.focus();
      }
    }

    function closePicker(returnFocus) {
      if (!pickerPanel || pickerPanel.hidden) return;
      pickerPanel.hidden = true;
      if (pickerBackdrop) pickerBackdrop.hidden = true;
      pickerButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) pickerButton.focus();
    }

    function visibleOptions() {
      return Array.prototype.slice.call(pickerPanel.querySelectorAll('.journal-option')).filter(function (option) {
        return !option.disabled && !option.closest('li').hidden;
      });
    }

    if (picker) {
      pickerButton.addEventListener('click', function () {
        if (pickerPanel.hidden) openPicker();
        else closePicker(false);
      });

      if (pickerSearch) {
        pickerSearch.addEventListener('input', function () { filterPicker(pickerSearch.value); });
        pickerSearch.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          var first = visibleOptions().filter(function (option) { return option.getAttribute('data-value') !== ''; })[0];
          if (first) first.click();
        });
      }

      pickerPanel.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        var options = visibleOptions();
        if (!options.length) return;
        event.preventDefault();
        var index = options.indexOf(document.activeElement);
        var next;
        if (index === -1) next = event.key === 'ArrowDown' ? 0 : options.length - 1;
        else next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) {
          if (pickerSearch) pickerSearch.focus();
        } else if (next < options.length) {
          options[next].focus();
        }
      });

      picker.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !picker.contains(event.relatedTarget)) closePicker(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !pickerPanel.hidden) {
          event.preventDefault();
          closePicker(true);
        }
      });

      document.addEventListener('click', function (event) {
        if (!picker.contains(event.target)) closePicker(false);
      });
    }

    // ---------- Initial state from the URL, so filtered views can be shared and survive a reload ----------

    if (window.URLSearchParams) {
      var params = new URLSearchParams(window.location.search);
      var type = params.get('topic') || params.get('type') || '';
      var brand = params.get('brand') || '';
      var q = (params.get('q') || '').trim().toLowerCase();
      if (type && hasControl('type', type)) state.type = type;
      if (brand && hasControl('brand', brand)) state.brand = brand;
      if (q) {
        state.q = q;
        if (search) search.value = params.get('q');
      }
    }

    root.addEventListener('click', function (event) {
      var control = event.target.closest('[data-filter]');
      if (control) {
        if (control.disabled) return;
        var group = control.getAttribute('data-filter');
        var value = control.getAttribute('data-value');
        state[group] = state[group] === value ? '' : value;
        state.limit = perLoad;
        render();
        if (picker && picker.contains(control)) closePicker(true);
        return;
      }

      if (event.target.closest('[data-journal-picker-close]')) {
        closePicker(true);
        return;
      }

      if (event.target.closest('[data-journal-clear]')) {
        state.type = '';
        state.brand = '';
        state.q = '';
        state.limit = perLoad;
        if (search) search.value = '';
        render();
        return;
      }

      if (event.target.closest('[data-journal-more]')) {
        var previousLimit = state.limit;
        state.limit += perLoad;
        render();
        var shown = cards.filter(function (card) { return !card.hidden; });
        var firstNew = shown[previousLimit];
        var link = firstNew && firstNew.querySelector('a');
        if (link) link.focus();
      }
    });

    if (search) {
      var timer;
      search.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          state.q = search.value.trim().toLowerCase();
          state.limit = perLoad;
          render();
        }, 120);
      });
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });
    }

    render();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-journal]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
